import { render, staticRenderFns } from "./VisualCard.vue?vue&type=template&id=0fce34eb&"
import script from "./VisualCard.vue?vue&type=script&lang=js&"
export * from "./VisualCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports